import React, { useEffect, useState } from "react";

const ProjectCategories = (props) => {
    const { filterProject } = props;
    const [ProjectCategories, setProjectCategories] = useState([]);
    const [loading, setloading] = useState([true]);

    //fetch  ServerProject
    const url = "https://coderchefserver.herokuapp.com/project_categories";
    useEffect(() => {
        fetch(url)
            .then((res) => res.json())
            .then((project) => {
                setProjectCategories(project);
                setloading(false);
            });
    }, []);
    return (
        <div className="project_categories_area ">
            <div className="right_text">
                <h3>Project CATEGORIES</h3>
            </div>
            <div className="row">
                <div className=" col-md-6 col-4">
                    {loading ? (
                        <div className="text-center mt_30 mb_30">
                            <div
                                className="spinner-border text-warning"
                                role="status"
                            >
                                <span className="visually-hidden">
                                    Loading...
                                </span>
                            </div>
                        </div>
                    ) : (
                        ProjectCategories.map((e) => (
                            <div className="categories_link" key={e._id}>
                                <i className="fal fa-long-arrow-right"></i>
                                <a
                                    href="#"
                                    onClick={() => filterProject(e.categories)}
                                >
                                    {e.categories}
                                </a>
                            </div>
                        ))
                    )}
                </div>
                <div className="col-md-6 col-8">
                    <div className="d-flex justify-content-center">
                        <div className="ads160_600"></div>
                        <div className="ads336_280"></div>
                        <div className="ads320_100"></div>
                        <div className="ads200_200"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectCategories;
